import { render, staticRenderFns } from "./CookieControl.vue?vue&type=template&id=79cad8cd&scoped=true"
import script from "./CookieControl.vue?vue&type=script&lang=js"
export * from "./CookieControl.vue?vue&type=script&lang=js"
import style0 from "./CookieControl.vue?vue&type=style&index=0&id=79cad8cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79cad8cd",
  null
  
)

export default component.exports